import React from "react";
import Lightbox from "react-image-lightbox";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Collapse, Form, Label, Media, Row, Table, Modal, ModalBody, ModalFooter } from "reactstrap";
import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import ApiRest from "../../ayudas/apiRest";
import { MINUTOS, TAMANIO_IMG_COLUMNAS_LG, TAMANIO_IMG_COLUMNAS_SM, TAMANIO_IMG_COLUMNAS_XS } from "../../ayudas/constantes";
import _valid from "../../validations";

export default class TareaInformacion extends React.Component {

    constructor(props) {
        super(props);
        const hayRegistro = _valid(props.datos);
        this.apiRest = new ApiRest(props);
        this.state = {
            idRegistro: props.props,
            registro: hayRegistro && props.datos.registro ? props.datos.registro : {
                tarea_descripcion: "",
                tarea_nota: "",
                img_solicitud_tarea_trabajada: "",
                img_solicitud_tarea_trabajada_2: "",
                img_solicitud_tarea_trabajada_3: ""
            },
            colapsar: true,
            imgSolicitudTrabajadaBase64: hayRegistro && _valid(props.datos.imgSolicitudTrabajadaBase64) ? props.datos.imgSolicitudTrabajadaBase64 : undefined,
            imgSolicitudTrabajadaBase64_2: hayRegistro && _valid(props.datos.imgSolicitudTrabajadaBase64_2) ? props.datos.imgSolicitudTrabajadaBase64_2 : undefined,
            imgSolicitudTrabajadaBase64_3: hayRegistro && _valid(props.datos.imgSolicitudTrabajadaBase64_3) ? props.datos.imgSolicitudTrabajadaBase64_3 : undefined,
            verImagenEnGrande: false,

            colapsarColaborador: true,
            colapsarArticulo: true,

            colaboradores_asociados: [],
            articulos_asociados: [],
        };
    }

    componentDidMount() {
        /* NECESITAMOS EL ID DE SOLICITUD O LOS DATOS DE LA SOLICITUD */
        const { idRegistro } = this.state;
        if (_valid(idRegistro)) {
            this.apiRest.getWithFiles('/solicitud/' + idRegistro).then(resultado => {
                if (resultado.exitoso) {
                    let nuevoEstado = { "registro": resultado.data };
                    if (_valid(resultado.imgSolicitudTrabajadaBase64)) {
                        nuevoEstado["imgSolicitudTrabajadaBase64"] = resultado.imgSolicitudTrabajadaBase64;
                    }
                    if (_valid(resultado.imgSolicitudTrabajadaBase64_2)) {
                        nuevoEstado["imgSolicitudTrabajadaBase64_2"] = resultado.imgSolicitudTrabajadaBase64_2;
                    }
                    if (_valid(resultado.imgSolicitudTrabajadaBase64_3)) {
                        nuevoEstado["imgSolicitudTrabajadaBase64_3"] = resultado.imgSolicitudTrabajadaBase64_3;
                    }
                    this.setState(nuevoEstado, () => {
                        this.obtenerColaboradoresAsociados();
                        this.obtenerArticulosAsociados();
                    });
                }
            });
        } else {
            this.obtenerColaboradoresAsociados();
            this.obtenerArticulosAsociados();
        }

    }

    colapsarTablaAsociaciones = estadoAColapsar => {
        this.setState(estadoAnterior => ({ ...estadoAnterior, [estadoAColapsar]: !estadoAnterior[estadoAColapsar] }));
    }

    //========================================================
    // Obtener datos
    //========================================================
    obtenerColaboradoresAsociados() {
        this.apiRest.get('/solicitudesColaboradores/' + this.state.registro.id).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ colaboradores_asociados: resultado.data });
            }
        });
    }

    obtenerArticulosAsociados() {
        this.apiRest.get('/solicitudesArticulos/' + this.state.registro.id).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ articulos_asociados: resultado.data });
            }
        });
    }

    render() {
        const {
            registro,
            colapsar,

            colapsarColaborador,
            colapsarArticulo,

            colaboradores_asociados,
            articulos_asociados,

            imgSolicitudTrabajadaBase64,
            imgSolicitudTrabajadaBase64_2,
            imgSolicitudTrabajadaBase64_3,
            verImagenEnGrande,
        } = this.state;

        return (
            <div>
                <React.Fragment>
                    <Card>
                        <CardBody>
                            <Link onClick={() => this.colapsarTablaAsociaciones("colapsar")} className="text-dark" to="#">
                                <div className="p-4">
                                    <Media className="d-flex align-items-center">
                                        <div className="me-3">
                                            <i className="uil uil-receipt text-primary h2"></i>
                                        </div>
                                        <div className="flex-1 overflow-hidden">
                                            <h5 className="font-size-16 mb-1">Tareas / Trabajos</h5>
                                            <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                        </div>
                                        <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                    </Media>
                                </div>
                            </Link>
                            {
                                _valid(registro.id) &&
                                <Collapse isOpen={colapsar}>
                                    {/* COLABORADORES INVOLUCRADOS */}
                                    <Row>
                                        <Col className="col-12">
                                            <Card>
                                                <CardBody>
                                                    <Link onClick={() => this.colapsarTablaAsociaciones("colapsarColaborador")} className="text-dark" to="#">
                                                        <div className="p-4">
                                                            <Media className="d-flex align-items-center">
                                                                <div className="me-3">
                                                                    <i className="fas fa-clipboard text-primary h2"></i>
                                                                </div>
                                                                <div className="flex-1 overflow-hidden">
                                                                    <h5 className="font-size-16 mb-1">Colaboradores involucrados en la tarea</h5>
                                                                </div>
                                                                <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                            </Media>
                                                        </div>
                                                    </Link>
                                                    {
                                                        _valid(colaboradores_asociados) && (
                                                            <Collapse isOpen={colapsarColaborador}>
                                                                <Table className="table table-sm m-0">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Nombre del colaborador</th>
                                                                            <th>Horas</th>
                                                                            <th>Minutos</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            colaboradores_asociados.map(involucrado =>
                                                                                <tr key={involucrado.colaborador}>
                                                                                    <td>
                                                                                        <p>{involucrado.nombre_colaborador}</p>
                                                                                    </td>
                                                                                    <td>
                                                                                        <p>{involucrado.horas}</p>
                                                                                    </td>
                                                                                    <td>
                                                                                        <p>{MINUTOS[registro.minutos].label}</p>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                    </tbody>
                                                                </Table>
                                                            </Collapse>
                                                        )
                                                    }
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                    {/* ASOCIAR ARTICULOS */}
                                    <Row>
                                        <Col className="col-12">
                                            <Card>
                                                <CardBody>
                                                    <Link onClick={() => this.colapsarTablaAsociaciones("colapsarArticulo")} className="text-dark" to="#">
                                                        <div className="p-4">
                                                            <Media className="d-flex align-items-center">
                                                                <div className="me-3">
                                                                    <i className="far fa-list-alt text-primary h2"></i>
                                                                </div>
                                                                <div className="flex-1 overflow-hidden">
                                                                    <h5 className="font-size-16 mb-1">Materiales utilizados</h5>
                                                                </div>
                                                                <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                            </Media>
                                                        </div>
                                                    </Link>
                                                    {
                                                        _valid(articulos_asociados) && (
                                                            <Collapse isOpen={colapsarArticulo}>
                                                                <Table className="table table-sm m-0">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Código</th>
                                                                            <th>Nombre, marca y serie del articulo</th>
                                                                            <th>Cantidad</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            articulos_asociados.map(articuloAsociado =>
                                                                                <tr key={articuloAsociado.id}>
                                                                                    <td>
                                                                                        <p>{articuloAsociado.codigo_articulo}</p>
                                                                                    </td>
                                                                                    <td>
                                                                                        <p>{articuloAsociado.nombre_articulo}</p>
                                                                                    </td>
                                                                                    <td>
                                                                                        <p>{articuloAsociado.cantidad}</p>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                    </tbody>
                                                                </Table>
                                                            </Collapse>
                                                        )
                                                    }
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <hr />
                                    {/* RESTO DE DATOS */}
                                    <Form>
                                        <div>
                                            <Row>
                                                <Col lg={6}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="tarea_descripcion" className="form-label">
                                                            Trabajo o tarea realizada
                                                        </Label>
                                                        <p>{registro.tarea_descripcion}</p>
                                                    </div>
                                                </Col>
                                                <Col lg={6}>
                                                    <div className="mb-3 mb-4">
                                                        <Label className="form-label">
                                                            Colaborador que acepta
                                                        </Label>
                                                        <p>{_valid(registro.colaborador_que_acepta_seleccionado) && registro.colaborador_que_acepta_seleccionado.label}</p>
                                                    </div>
                                                </Col>
                                                <Col lg={6}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="tarea_nota" className="form-label">
                                                            Nota
                                                        </Label>
                                                        <p>{registro.tarea_nota}</p>
                                                    </div>
                                                </Col>
                                                <Col lg={TAMANIO_IMG_COLUMNAS_LG} sm={TAMANIO_IMG_COLUMNAS_SM} xs={TAMANIO_IMG_COLUMNAS_XS}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="img_solicitud_tarea_trabajada" className="form-label">
                                                            Imagen
                                                        </Label>
                                                        <div onClick={() => this.setState({ verImagenEnGrande: true })}>
                                                            {imgSolicitudTrabajadaBase64 && <img width="100%" src={`data:image/jpeg;base64,${imgSolicitudTrabajadaBase64}`} alt="solicitud" />}
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col lg={TAMANIO_IMG_COLUMNAS_LG} sm={TAMANIO_IMG_COLUMNAS_SM} xs={TAMANIO_IMG_COLUMNAS_XS}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="img_solicitud_tarea_trabajada_2" className="form-label">
                                                            
                                                        </Label>
                                                        <div onClick={() => this.setState({ verImagenEnGrande: true })}>
                                                            {imgSolicitudTrabajadaBase64_2 && <img width="100%" src={`data:image/jpeg;base64,${imgSolicitudTrabajadaBase64_2}`} alt="solicitud" />}
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col lg={TAMANIO_IMG_COLUMNAS_LG} sm={TAMANIO_IMG_COLUMNAS_SM} xs={TAMANIO_IMG_COLUMNAS_XS}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="img_solicitud_tarea_trabajada_3" className="form-label">
                                                            
                                                        </Label>
                                                        <div onClick={() => this.setState({ verImagenEnGrande: true })}>
                                                            {imgSolicitudTrabajadaBase64_3 && <img width="100%" src={`data:image/jpeg;base64,${imgSolicitudTrabajadaBase64_3}`} alt="solicitud" />}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Form>
                                </Collapse>
                            }
                        </CardBody>
                    </Card>
                    <Modal isOpen={verImagenEnGrande} size="lg">
                        <ModalBody>
                            <Row>
                                <img height="100%" width="100%" src={`data:image/jpeg;base64,${imgSolicitudTrabajadaBase64}`} alt="solicitud" />
                            </Row>
                            <Row>
                                <img height="100%" width="100%" src={`data:image/jpeg;base64,${imgSolicitudTrabajadaBase64_2}`} alt="solicitud" />
                            </Row>
                            <Row>
                                <img height="100%" width="100%" src={`data:image/jpeg;base64,${imgSolicitudTrabajadaBase64_3}`} alt="solicitud" />
                            </Row>
                        </ModalBody>
                        <ModalFooter className="text-center">
                            < MDBBtn color="danger" onClick={() => this.setState({ verImagenEnGrande: false })}>
                                <MDBIcon icon="fas fa-times" />
                            </ MDBBtn>
                        </ModalFooter>
                    </Modal>
                </React.Fragment>                
            </div >
        );
    }
}